import React from "react";
import { TableHeaderWrapper } from "./Styles";

const TableHeader = (props) => {
  return <TableHeaderWrapper>{props.children}</TableHeaderWrapper>;
};

export default TableHeader;
